import React from 'react';
import { Card, Row, Col, Input, Button, Form, Popconfirm, message } from 'antd';
import { onPost, api } from '../../../../core/api3';

class QuantRobotStrategyDataView extends React.Component {

    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.getStrategyDataCard = this.getStrategyDataCard.bind(this);
    }

    onClick(type) {
        switch (type) {
            case 'update':
                this.props.form.validateFieldsAndScroll((error, fields) => {
                    if (error) {
                        return;
                    }
                    onPost(api.updateQuantRobot.url, api.updateQuantRobot.params(this.props.robotId, JSON.stringify(fields))).then(response => {
                        if (response === undefined) {
                            return;
                        }
                        message.success('更新参数成功');
                    });
                });
                break;
            default:
                break;
        }
    }

    getStrategyDataCard() {
        let rowlist = [];
        let rowSize = Math.ceil(this.props.strategyData.length / 4);
        for (let i = 0; i < rowSize; i++) {
            rowlist.push([]);
        }
        this.props.strategyData.forEach((data, index) => {
            rowlist[Math.floor(index / 4)].push(data);
        });
        return <Card title="策略参数" bordered={false}>
            <Form className="form-inline">
                {rowlist.map((row, index) => {
                    return <Row gutter={20} key={'row_' + index} className={index === 0 ? '' : 'box-row'}>
                        {row.map((data, index2) => {
                            return <Col key={'col_' + index + '_' + index2} span="6" push="0">
                                <Form.Item label={data.describe} style={{ marginBottom: 0 }} >
                                    {this.props.form.getFieldDecorator(data.key, {
                                        initialValue: data.value,
                                        rules: [{ required: true, message: '请输入' + data.describe }]
                                    })(
                                        <Input placeholder={'请输入' + data.describe} maxLength="20" disabled={this.props.status !== 0} />
                                    )}
                                </Form.Item>
                            </Col>
                        })}
                    </Row>
                })}
                <Form.Item style={{ marginBottom: 0, marginTop: 20 }}>
                    <Popconfirm title="确定要更新参数？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('update')}>
                        <Button type="primary" disabled={this.props.status !== 0}>更新参数</Button>
                    </Popconfirm>
                </Form.Item>
            </Form>
        </Card>
    }

    render() {
        return (
            <div>
                {this.getStrategyDataCard()}
            </div>
        );
    }

}

const QuantRobotStrategyDataCard = Form.create()(QuantRobotStrategyDataView);
export default QuantRobotStrategyDataCard;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/quant/QuantRobotStrategyDataCard.jsx